<div [formGroup]="taxWithholdingsFormGroup" id="ach-tax-withholdings">
    <div id="tax-withholding-title" class="small-bottom-spacer">Tax withholding</div>

    <!-- NRA BANNER -->
    <mm-banners *ngIf="nraIndicator" [bannerText]="[nraText]" [type]="'information'"></mm-banners>

    <!-- RMD BANNER -->
    <mm-banners *ngIf="showRmdBanner" [bannerText]="[rmdAlertText]" [type]="'information'"></mm-banners>

    <!-- COMBINED FED AND STATE TAX ERROR -->
    <mm-banners *ngIf="parentForm?.errors" [bannerText]="[fedAndStateTaxSumError]" [type]="'error'" data-testid="fed-and-state-tax-error"></mm-banners>

    <mm-banners *ngIf="CTWEWarningMessage" [bannerText]="[achCTWEAuthorizationError]"
    [hyperlink]="noInstructionsErrorLink" [achRedirect]="true" [type]="'error'">
    </mm-banners>

    <!-- DIST Q BANNER -->
    <mm-banners *ngIf="selectedDistributionReason === qualifiedDistReason"
    [bannerText]="[qualifiedDistReasonWarning]" [type]="'warning'"
    data-testid="qualified-dist-reason-banner"></mm-banners>

    <div id="tax-withholding-text" class="medium-bottom-spacer">
        <span>{{taxWithholdingText}}</span>
    </div>

    <div class="row">
        <!-- FED TAX -->
        <div class="tax-container">
            <div *ngIf="!nraIndicator" class="tax-percent" id="federal-percent">
                <div id="federal-tax-label" data-testid="fed-tax-title" [class.error-text]="isFedTaxInvalid">Federal tax</div>

                <input *ngIf="!isRecurring; else elseBlock" type="text" formControlName="fedTaxPercent" (blur)="onFedTaxBlur()"
                    [class.is-invalid]="fedTaxPercent.invalid"
                    (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                    data-testid="fed-tax-input" maxlength="10">

                <ng-template #elseBlock>
                    <div class="sdps-form-element__control sdps-form-element__control--addon input-container">
                        <button class="sdps-button sdps-button--secondary sdps-button--input-right sdps-button--small calc-button" data-testid="fedCalculator"
                            (click)="onFedTaxCalculatorClick()" [attr.disabled]="fedTaxPercent.disabled || !amount.value || amount.invalid || null">
                            <i class="sch-calculator calc-icon"></i>
                        </button>
                        <input type="text" formControlName="fedTaxPercent" (blur)="onFedTaxBlur()"
                            [class.is-invalid]="fedTaxPercent.invalid" class="sdps-input sdps-input--small sdps-input--addon-right tax-field-input"
                            (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                            data-testid="fed-tax-input" maxlength="10">
                    </div>
                </ng-template>

                <div *ngIf="fedTaxPercent.invalid" class="alert-text" data-testid="fed-tax-error">
                    {{fedTaxError}}
                </div>
            </div>
        </div>
        <!-- STATE TAX -->
        <div id="state-tax-container" data-testid="state-tax-field">
            <div class="tax-container">
                <div class="tax-percent" id="state-percent">
                  <div id="federal-tax-label" data-testid='state-tax-title' [class.error-text]="isStateTaxInvalid">{{saStateTaxLabel}}</div>

                    <input *ngIf="!isRecurring || nraIndicator; else elseBlock" type="text" formControlName="stateTaxPercent" (blur)="onStateTaxBlur()"
                        [class.is-invalid]="stateTaxPercent.invalid"
                        (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                        data-testid="state-tax-input" maxlength="10">

                    <ng-template #elseBlock>
                        <div class="sdps-form-element__control sdps-form-element__control--addon input-container">
                            <button class="sdps-button sdps-button--secondary sdps-button--input-right sdps-button--small calc-button" data-testid="stateCalculator"
                                (click)="onStateTaxCalculatorClick()" [attr.disabled]="stateTaxPercent.disabled || !amount.value || amount.invalid || null">
                                <i class="sch-calculator calc-icon"></i>
                            </button>
                            <input type="text" formControlName="stateTaxPercent" (blur)="onStateTaxBlur()"
                                [class.is-invalid]="stateTaxPercent.invalid" class="sdps-input sdps-input--small sdps-input--addon-right tax-field-input"
                                (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                                data-testid="state-tax-input" maxlength="10">
                        </div>
                    </ng-template>

                    <div *ngIf="stateTaxPercent.invalid" class="alert-text" data-testid="state-tax-error">
                        {{stateTaxError}}
                    </div>
                </div>
            </div>
            <!-- VIEW STATE TAX LINK -->
            <div>
                <div id="view-state-tax-info-link">
                    <a href="https://www.schwab.com/resource/state-income-tax-withholding-information-for-individual-retirement-accounts"
                        target="_blank">View state tax information</a>
                </div>
            </div>
        </div>

        <!-- DISTRIBUTION REASON -->
        <div id="distribution-reason-container">
            <div class="input-container">
                <mm-select-dropdown-control id="distribution-reason-select" [parentForm]="taxWithholdingsFormGroup" label="distributionReasonModel.title"
                    [selectModel]="distributionReasonModel" [defaultValue]="distributionReasonControl" [tooltipVerbiage]="distributionReasonTooltip">
                </mm-select-dropdown-control>
            </div>
            <a id="client-ira-agreement-link" (click)="displayIraAgreementModal()">View client IRA agreement</a>
        </div>
    </div>
    <cashiering-ira-agreement-modal [showModal]="showCashieringIRAAgreementModal"></cashiering-ira-agreement-modal>
    <mm-twe-calculator-modal [showModal$]="showTweCalculatorModal" [isFedTax$]="isFedTax$.asObservable()" (onApplyWithholdings)="setTaxPercentValue($event.fedTaxCalculatedPercent, $event.stateTaxCalculatedPercent)"></mm-twe-calculator-modal>
</div>
